// extracted by mini-css-extract-plugin
export default {"replies":"tweet-replies_replies__nH094","link":"tweet-replies_link__kWZAV","text":"tweet-replies_text__POT5-"};